// extracted by mini-css-extract-plugin
module.exports = {"QuestionTooltip":"QuestionTooltip_QuestionTooltip__d5aaX","Row":"QuestionTooltip_Row__WvBIT","Image":"QuestionTooltip_Image__EPqKl","Text":"QuestionTooltip_Text__hHx_J"};